import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { LookupService } from '../../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../../services/lookups/lookupadmin.service';
import { Location } from '../../../../models/user.model';
import { ReportAutoPublishPolicy, ReportCategory } from '../../../../models/report.model';
import { elementStart } from '@angular/core/src/render3/instructions';

@Component({
  selector: 'app-reportcategory-detail',
  templateUrl: './reportcategory-detail.component.html',
  styleUrls: ['./reportcategory-detail.component.css']
})
export class ReportcategoryDetailComponent implements OnInit {
  autoPublishPolicies:ReportAutoPublishPolicy[];
  programAreas: Location[] = [];
  parentReportCategories:ReportCategory[];
  controlDisable:boolean=false;
  @Output() showHideReportCategoryDetailDlg = new EventEmitter<boolean>();
  @Output() refreshDataSource=new EventEmitter<boolean>();
  reportCategoryDetailForm: FormGroup;
  constructor(private fb: FormBuilder, 
    private lookupService: LookupService,
    private lookupAdminService:LookupAdminService,
    private notifier: NotifierService) { }

  ngOnInit() {
    this.reportCategoryDetailForm = this.fb.group({
      Id: [''],
      categoryName: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9]*$/)]],
      programArea: ['', Validators.required],
      parentCategory:['',Validators.required],
      autoPublishPolicy:['', Validators.required],
      isActive:['',Validators.required],
      //lastUpdatedBy:[''],
      lastUpdatedDateTime:['']
    });
    this.LoadLookupValues();

    
  }

  private LoadLookupValues()
  {
    this.lookupService.getAllActiveProgramAreas$().subscribe(data=>{
      this.programAreas =data;

    });

    this.lookupService.getAllActiveReportAutoPublishPolicies$().subscribe(data=>{
      this.autoPublishPolicies =data;
    });

    this.lookupService.getAllActiveReportCategories$().subscribe(data=>{
       this.parentReportCategories = data;
    });
  }

  onChangeCategory(selectedCategory:ReportCategory)
  {
       var area = this.programAreas.filter(x=>x.id ===selectedCategory.programAreaId);
       if(area.length >0)
       {
          this.reportCategoryDetailForm.patchValue({programArea:area[0]});
          this.controlDisable =true;
       }
       else{
        this.reportCategoryDetailForm.controls["programArea"].reset();
        this.controlDisable=false;
       }
  }
  showReportCategoryDetail(reportCategoryId: number,isNew:boolean)
  {
    
    this.reportCategoryDetailForm.reset();
     if(isNew)
     {
         this.createNewReportCategory(reportCategoryId);
     }
     else{
        this.updateReportCategory(reportCategoryId);
     }


  }

  private createNewReportCategory(parentCategoryId:number)
  {
      var parentCategory = this.parentReportCategories.filter(x=>x.id === parentCategoryId);
      if(parentCategory.length >0)
      {
        this.reportCategoryDetailForm.patchValue({parentCategory:parentCategory[0],Id:String(0)});
        this.onChangeCategory(parentCategory[0]);
        
      }
      
  }

  private updateReportCategory(reportCategoryId:number)
  {

       this.lookupService.getReportCategoryById(reportCategoryId).subscribe(data=>{
        var reportCategory = data;
        if(reportCategory)
        {
           this.reportCategoryDetailForm.patchValue({Id:reportCategory.id,
                                                    categoryName:reportCategory.categoryName,
                                                    isActive:String(reportCategory.isActive),
                                                    lastUpdatedDateTime:new Date(reportCategory.lastUpdatedDatetime).toLocaleString() });
          var parentCategory = this.parentReportCategories.find(x=>x.id === reportCategory.parentCategoryId);
           var policy =this.autoPublishPolicies.find(x=>x.id === reportCategory.autoPublishPolicyId);
           var programArea  = this.programAreas.find(x=>x.id === reportCategory.programAreaId);
           this.reportCategoryDetailForm.patchValue({autoPublishPolicy:policy,parentCategory:parentCategory,programArea:programArea});

        }

       });
      
  }

  onCancelReportCategoryDetail()
  {
    this.reportCategoryDetailForm.reset();
    this.showHideReportCategoryDetailDlg.emit(false);
    this.refreshDataSource.emit(true);
  }

  onSaveReportCategoryDetail()
   {
     if(this.reportCategoryDetailForm.valid)
     {
       var reportCategory = Object.assign(new ReportCategory(),this.reportCategoryDetailForm.value);
       reportCategory.programAreaId = reportCategory.programArea.id;
       reportCategory.autoPublishPolicyId =reportCategory.autoPublishPolicy.id;
       reportCategory.parentCategoryId = reportCategory.parentCategory.id;
       //console.log(reportCategory);

       this.lookupAdminService.saveReportCategory$(reportCategory).subscribe(resp=>{
         if(resp.ok)
         {
          this.notifier.notify('success', 'Report Category saved successfully');
          this.LoadLookupValues();
         }

       },error=>{
        this.notifier.notify('error', 'Failed to save Report Category, contact tech support');
       });


       
    }
  }





}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/reportcategory/reportcategory-detail/reportcategory-detail.component.ts